import { View, styled, Image } from 'tamagui'
import { useEffect } from 'react'
import { X } from '@tamagui/lucide-icons'
import { useAppStore } from '@/store'

const Overlay = styled(View, {
  position: 'absolute' as any,
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 5000,
})

const CloseButton = styled(View, {
  position: 'absolute' as any,
  width: 36,
  height: 36,
  borderRadius: 18,
  backgroundColor: 'rgba(0, 0, 0, 0.6)',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
  hoverStyle: {
    backgroundColor: 'rgba(0, 0, 0, 0.8)',
  },
  // @ts-expect-error -- web transition
  style: { transition: 'background-color 150ms ease' },
})

const LightboxImage = styled(Image, {
  maxWidth: '90%' as any,
  maxHeight: '90%' as any,
  borderRadius: '$borderRadiusMd',
})

export function ImageLightbox() {
  const { imagePreviewUrl, setImagePreviewUrl } = useAppStore()

  useEffect(() => {
    if (!imagePreviewUrl) return

    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        setImagePreviewUrl(null)
      }
    }
    document.addEventListener('keydown', handleKeyDown)
    return () => document.removeEventListener('keydown', handleKeyDown)
  }, [imagePreviewUrl, setImagePreviewUrl])

  if (!imagePreviewUrl) return null

  return (
    <Overlay
      // @ts-expect-error -- web fixed positioning
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.85)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
      onPress={() => setImagePreviewUrl(null)}
    >
      <CloseButton
        // @ts-expect-error -- web fixed positioning
        style={{ position: 'fixed', top: 16, right: 16 }}
        onPress={() => setImagePreviewUrl(null)}
      >
        <X size={20} color="white" />
      </CloseButton>

      <View onPress={(e: any) => e.stopPropagation()}>
        <LightboxImage
          source={{ uri: imagePreviewUrl }}
          // @ts-expect-error -- web image sizing
          style={{ maxWidth: '90vw', maxHeight: '90vh', objectFit: 'contain' }}
        />
      </View>
    </Overlay>
  )
}
